import ArrowLeft from "./SVG/arrowLeft.svg?react";

const ArrowLeftIcon = () => {
  return <ArrowLeft />;
};

export default ArrowLeftIcon;
